export const en = {
  tip: "Tip",
  fatInputTip: "If you want to write {val}.0 so enter exact value with decimal or enter {val}0 with 3 digit.",
  snfInputTip: "If you want to write {val}.0 so enter exact value with decimal or enter {val}0 with 3 digit.",
  // Header/Navigation
  // appTitle: "Dairy Name TESTINGg Dairy",
  home: "Home",
  logout: "Logout",

  // Hire Person
  hirePersonBannerHeading: "Don't want to do collections yourself?",
  hirePersonBannerSubheading: "Hire a person to do collections for you",
  hirePersonModalTitle: "Hire a Person for Collections",
  hirePersonCostEstimate: "Cost Estimate",
  hirePersonCostEstimateDesc: "Pricing typically ranges from ₹500 to ₹3,000-₹4,000 per month depending on the number of average daily collections and the volume of work required.",
  hirePersonContactNetpy: "Contact Dudhiya Support",
  hirePersonContactNetpyDesc: "Reach out to us to get a tailored quote and connect with reliable collection personnel in your area.",
  hirePersonCallNetpy: "Call Netpy",
  hirePersonWhatsAppNetpy: "WhatsApp Netpy",

  // Dashboard
  dashboard: "Dashboard",
  dairyName: "Dairy Name",
  walletBalance: "Wallet",
  addMoney: "Add Money",
  notAvailable: "Not Available",

  // Rate Information
  milkRate: "Milk Rate",
  currentRate: "Current Rate",
  currentMilkRate: "Current Milk Rate",
  editRate: "Edit Rate",
  rateType: "Rate Type",
  selectRateType: "Select Rate Type",
  submit: "Submit",
  submitting: "Submitting...",
  save: "Save",
  saving: "Saving...",
  cancel: "Cancel",

  // Dashboard Cards
  bulkRateUpdate: "Milk Rate Update In Bulk",
  bulkRateUpdateBtn: "Rate Update",
  bulkRateUpdateTooltip: "Change milk rate for multiple collections",
  rateSettings: "Rate Settings",
  updateRatesForMultipleCollections: "Update rates for multiple collections",
  configureMilkPricingAndRateTypes: "Configure milk pricing and rate types",
  updateMultipleCollectionsAtOnce: "Update multiple collections at once",
  previewBeforeApplyingChanges: "Preview before applying changes",
  setCurrentMilkRate: "Set current milk rate",
  setMilkRateNow: "Set your milk rate now!",
  managePricingParameters: "Manage pricing parameters",
  applyToSpecificDateRanges: "Apply to specific date ranges",
  configureRateType: "Configure rate type (FAT+SNF, FAT+CLR, etc.)",

  // Collection Cards
  regularMilkCollections: "Regular milk collections",
  proportionalCollections: "Proportional collections",
  generateDetailedReports: "Generate detailed reports",
  proRataCollection: "Pro Rata Collection",
  standardCollection: "Standard Collection",
  notAvailableWithKGLitersRateType: "Not available with KG/Liters rate type",
  selectCollectionType: "Select Collection Type",
  applyFilter: "Apply Filter",
  applying: "Applying...",
  applyRateChanges: "Apply Rate Changes",

  // Wallet Modal
  addToWallet: "Add to Wallet",
  topUpWalletInstantlyUsingRazorpay: "Top up your wallet instantly using Razorpay",
  quickRecharge: "Quick Recharge",
  walletRecharge: "Wallet Recharge",

  // Add Money Modal
  moneyAddedToWalletMessage: "Money will be added to your wallet within 5 mins after successful payment.",
  refreshPage: "Refresh the Page",
  please: "Please",
  enterAmount: "Enter amount",
  enterValidAmount: "Enter a valid amount (₹1 or more)",
  youWillGetExtraOnRecharge: "You will get ₹{amount} extra on this recharge!",
  youWillGet10PercentBonus: "You will get ₹{amount} extra on this recharge!",
  youWillGet5PercentBonus: "You will get ₹{amount} extra on this recharge!",
  continueToPayment: "Continue to Payment",
  loading: "Loading...",

  // Rate Settings Modal
  saveSettings: "Save Settings",
  perKg: "/kg",
  milkRateHeading: "Milk Rate",
  milkRateAndRateSettingsSavedSuccessfully: "Milk rate ₹{currentRate}/kg and rate settings saved successfully!",

  // Collections
  addCollection: "Bulk Collection",
  viewCollections: "View Collections",
  standardCollections: "Collections",
  proRataCollections: "Pro Rata Collections",
  quickFiltersAndActions: "Quick Filters & Actions",
  refineCollectionsAndManageRatesInstantly: "Refine your collections and manage rates instantly",
  proRataFiltersAndActions: "Pro Rata Filters & Actions",
  targetCollectionsAndUpdateProRataRatesFaster: "Target collections and update pro rata rates faster",

  // Supplier Management
  addCustomer: "Add Supplier",
  viewCustomers: "View Suppliers",
  customerName: "Supplier Name",
  phoneNumber: "Phone Number",

  // Reports
  generateReport: "Generate Report",
  reports: "Reports",
  generateStandardReport: "Generate report",
  generateProRataReport: "Generate Report",

  // Wallet
  wallet: "Wallet",
  addFunds: "Add Funds",
  amount: "Amount",
  paymentSuccessful: "✅ Payment successful! Your wallet will be updated shortly.",
  paymentSuccessfulWithAmount: "✅ Payment successful! ₹{amount} added to your wallet.",
  paymentFailed: "Payment failed",
  paymentCancelled: "Payment cancelled. Please try again if you want to add funds.",
  paymentSessionTimedOut: "Payment session timed out. Please check if payment was completed.",
  paymentCancelledOrIncomplete: "Payment cancelled or incomplete. Please try again.",
  unableToVerifyPaymentStatus: "Unable to verify payment status. Please check your wallet balance.",
  failedToCreatePaymentLink: "Failed to create payment link. Please try again.",

  // Collection Details
  singleDateShift: "Single Date/Shift",
  multiDateShift: "Multi Date/Shift",
  date: "Date",
  customer: "Supplier",
  weight: "Weight",
  fatPercentage: "FAT %",
  snfPercentage: "SNF %",
  fatKg: "Fat Kg",
  snfKg: "SNF Kg",
  fatRate: "Fat Rate",
  snfRate: "SNF Rate",
  baseSNF: "Base SNF",
  totalAmount: "Total Amount",
  finalAmount: "Final Amount",
  avgFat: "Avg Fat",
  avgSnf: "Avg SNF",
  totalQuantity: "Total Quantity",
  totalFat: "Total Fat",
  totalSnf: "Total SNF",
  totalSolidWeight: "Total Solid Weight",

  // Common
  error: "Error",
  success: "Success",
  confirm: "Confirm",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  update: "Update",
  close: "Close",

  // Units
  kg: "kg",
  currency: "₹",

  // Messages
  loadingInformation: "Loading information...",
  loadingDairyInformation: "Loading dairy information...",
  loadingUserInformation: "Loading user information...",
  dairy: "Dairy",
  balance: "Balance",
  changeType: "Change Type",
  processing: "Processing...",
  submittingCollections: "Submitting Collections",
  processingCollections: "Processing {current} of {total} collections",
  noDataYet: "No data yet. Click 'Add Row' to begin adding collections.",
  loadingRateInformation: "Loading rate information...",

  // Footer
  allRightsReserved: "All rights reserved",
  poweredBy: "Powered by",

  // Login
  login: "Login",
  enterPhoneNumber: "Enter your 10-digit phone number",
  verifyOTP: "Verify OTP",
  enterOTP: "Enter OTP",
  changeNumber: "Change Number",

  // Language Names
  english: "English",
  hindi: "हिन्दी",
  punjabi: "ਪੰਜਾਬੀ",
  kannada: "ಕನ್ನಡ",

  // Bulk Collection
  bulkCollection: "Bulk Collection",
  prorataBulkCollection: "Bulk Collection",
  prorataViewCollections: "View Collections",
  bulkCollectionSpreadsheetView: "Bulk Collection - Spreadsheet View",
  backToDashboard: "Back to Dashboard",
  owner: "Owner",
  phone: "Phone",
  collectionDate: "Collection Date (for all rows)",
  collectionTime: "Collection Time (for all rows)",
  customerManagement: "Supplier Management",
  rateConfiguration: "Rate Configuration",
  addNewCustomer: "Add New Supplier",
  changeRates: "Change Rates",
  add1Row: "Add 1 Row",
  add5Rows: "Add 5 Rows",
  previewSubmit: "Preview & Submit",
  collectionDateEdit: "Collection Date",
  collectionTimeEdit: "Collection Time",

  // Table Headers
  serialNumber: "#",
  weightKg: "Weight (kg)",
  fatPercent: "FAT %",
  snfPercent: "SNF %",
  clr: "CLR",
  animalType: "Animal Type",
  actions: "Actions",

  // Form Fields
  searchCustomer: "Search supplier",
  time: "Time",
  rate: "Rate (₹)",

  // Options
  morning: "Morning",
  evening: "Evening",
  cow: "Cow",
  buffalo: "Buffalo",
  cowBuffalo: "Cow + Buffalo",
  mixed: "Mixed",

  // Shift Filter Options
  allShifts: "AM + PM",
  morningAm: "Morning (AM)",
  eveningPm: "Evening (PM)",

  // Actions
  submitAll: "Submit All",

  // New Supplier Modal
  name: "Name",
  fatherName: "Father's Name",
  village: "Village",
  address: "Address",
  enterCustomerName: "Enter supplier name",
  enterFatherName: "Enter father's name",
  enter10DigitPhone: "Enter 10-digit phone number",
  enterVillageName: "Enter village name",
  enterCompleteAddress: "Enter complete address",
  saveCustomer: "Save Supplier",
  newCustomer: "New Supplier",
  enterVillage: "Enter village",

  // Messages
  noCollectionsAdded: "No collections added yet. Click the button below to add a collection.",
  collectionSubmittedSuccessfully: "Collection submitted successfully!",
  collectionsSubmittedSuccessfully: "Collections submitted successfully!",
  collectionForCustomerSubmitted: "Collection for {customer} submitted successfully!",
  customerIsRequired: "Supplier is required",
  fatPercentIsRequired: "Fat percent is required",
  validFatPercentRequired: "Valid fat percent is required",
  weightIsRequired: "Weight is required",
  validWeightRequired: "Valid weight is required",
  snfPercentIsRequired: "SNF percent is required",
  validSnfPercentRequired: "Valid SNF percent is required",
  pleaseAddAtLeastOneCollection: "Please add at least one collection",
  fromCLR: "From CLR",
  noCustomersFound: "No suppliers found",

  // Placeholders
  egTenPointFive: "e.g. 10.5",
  egThreePointFive: "e.g. 3.5",
  egTwentySevenPointZero: "e.g. 27.0",
  egEightPointFive: "e.g. 8.5",
  egFiftyFivePointZero: "e.g. 55.0",

  // Preview Collections filters and sorting
  searchCustomerOrId: "Search by supplier name or ID...",
  filterByCustomer: "Search by Supplier",
  filterByDate: "Search by Date",
  filterByAnimal: "Filter by Animal",
  allAnimals: "All Animals",
  newestFirst: "Newest First",
  oldestFirst: "Oldest First",
  milkRateUpdate: "Milk Rate Update",
  bulkUpdateRateAndSnf: "Milk & Snf Update",
  changeMilkRate: "Change Milk Rate",
  sortTooltipNewestFirst: "Newest first by creation time (Change to oldest first)",
  sortTooltipOldestFirst: "Oldest first by creation time (Change to newest first)",
  sortingLabel: "Sorting:",
  sortingByCreationTime: "by creation time",

  // Additional translations for BulkCollectionV1
  lowWalletBalance: "Low Wallet Balance",
  walletBalanceLowMessage: "Your wallet balance is below ₹50. Please add funds to your wallet to ensure uninterrupted service.",
  currentBalance: "Current Balance",
  dismiss: "Dismiss",

  // Rate Configuration
  rateChart: "Rate Chart",
  previewAndSubmit: "Preview & Submit",
  noDataYetClickAddRow: "No data yet. Click \"Add Row\" to begin adding collections.",

  // Rate Type Options
  fatSnf: "FAT + SNF",
  fatClr: "FAT + CLR",
  litersOnly: "Liters Only",

  // Add Money Modal
  topUpWalletInstantly: "Top up your wallet instantly using Razorpay",

  // Rate Chart Modal
  fatStepUpRates: "FAT Step-up Rates",
  snfStepDownRates: "SNF Step-down Rates",
  rateAppliesWhenFatGreater: "Rate applies when FAT% is greater than step",
  rateAppliesWhenSnfLess: "Rate applies when SNF% is less than step",
  step: "Step (%)",
  addStep: "Add step",
  fatSnfRatio: "Fat/SNF Ratio",

  // Change Rates Modal
  baseSNFSetting: "Base SNF",
  clrConversionFactor: "CLR Conversion Factor",
  selectConversionFactor: "Select the conversion factor used in the CLR to SNF formula",

  // Messages and Alerts
  deleteConfirmation: "Are you sure you want to delete this collection?",
  pleaseAllowPopups: "Please allow popups to complete payment.",
  paymentLinkOpened: "Payment link opened in new tab. Complete payment there.",

  // Bonus Messages
  bonusMessage5Percent: "You will get ₹{amount} extra on this recharge!",
  bonusMessage10Percent: "You will get ₹{amount} extra on this recharge!",

  // Validation Messages
  customerNameRequired: "Supplier name is required",

  // Success Messages
  rateTypeUpdatedSuccessfully: "Rate type updated successfully!",
  newCustomerCreatedSuccessfully: "New supplier {name} created successfully!",

  // Error Messages
  someCollectionsHaveInvalidData: "Some collections have invalid data. Please check all fields and try again.",
  failedToSubmitCollection: "Failed to submit collection for {supplier}: {error}",
  failedToUpdateMilkRate: "Failed to update milk rate. Please try again.",
  failedToUpdateRateType: "Failed to update rate type. Please try again.",
  failedToCreateCustomer: "Failed to create supplier. Please try again.",

  // CLR Validation
  clrValueBelowMinimum: "CLR value {value} is below the minimum (13.1)",
  clrValueAboveMaximum: "CLR value {value} is above the maximum (34.0)",

  // Warning Messages
  warningFatPercentBelowMin: "Warning: Fat % below minimum {min}%",
  warningFatPercentAboveMax: "Warning: Fat % exceeds {max}%",
  warningSnfPercentBelowMin: "Warning: SNF % below minimum {min}%",
  warningSnfPercentAboveMax: "Warning: SNF % exceeds {max}%",
  warningClrBelowMin: "Warning: CLR value below {min}",
  warningClrAboveMax: "Warning: CLR value exceeds {max}",
  warningFatPercentBelowMinRaw: "Warning: Fat percentage below {min}%",
  warningFatPercentAboveMaxRaw: "Warning: Fat percentage exceeds {max}%",
  warningSnfPercentBelowMinRaw: "Warning: SNF percentage below {min}%",
  warningSnfPercentAboveMaxRaw: "Warning: SNF percentage exceeds {max}%",

  // Confirmation Messages
  confirmDeletion: "Confirm Deletion",
  areYouSureDeleteRow: "Are you sure you want to delete this row?",
  actionCannotBeUndone: "This action cannot be undone.",
  deleteThisRow: "Delete this row",
  deleteCollectionRow: "Delete Collection Row",
  rowWillBePermanentlyDeleted: "This row contains data that will be permanently deleted",
  areYouSureProceedDeletion: "Are you sure you want to proceed with deletion?",

  // Low Percentage Warning
  lowPercentageValue: "Low Percentage Value",
  enteredValueLessThan: "You have entered value less than {min}% for {field}",
  enteredProcessed: "Entered: {entered} → Processed: {processed}%",
  areYouSureProceedValue: "Are you sure you want to proceed with this value?",

  pleaseReviewBeforeSave: "Please review the edited collection before saving:",
  totalRecords: "Total Records:",
  confirmSubmit: "Confirm & Submit",

  // Rate Settings Modal
  selectTheFatToSnfRatioForRateCalculations: "Select the fat to SNF ratio for rate calculations",
  setTheBaseSnfPercentageForCalculations: "Set the base SNF percentage for calculations",

  // Add Money Modal
  offers: "Offers",
  rechargeOffers: "Recharge Offers",
  getExtraBonus: "Get Extra Bonus on Recharge",
  starterBonus: "Starter Bonus",
  premiumBonus: "Premium Bonus",
  bestValue: "BEST VALUE",

  // New Supplier Modal
  pleaseFillCustomerDetails: "Please fill in the supplier details. Fields marked with * are required.",
  createCustomer: "Create Supplier",
  savingCustomer: "Saving...",

  // Preview Collections Modals
  confirmDeleteCollection: "Confirm Deletion",
  areYouSureDeleteCollection: "Are you sure you want to delete this collection?",
  dateTime: "Date & Time",
  deleting: "Deleting...",
  deleteSuccess: "Collection deleted successfully",
  collectionDeletedSuccessfully: "Collection deleted successfully!",
  deleteFailed: "Failed to delete the collection. Please try again.",
  loadCollectionsFailed: "Failed to load collections. Please try again later.",
  loadCustomersFailed: "Failed to load suppliers. Please try again later.",
  pleaseSelectDate: "Please select a date",
  pleaseSelectBothDates: "Please select both from and to dates",
  toDateCannotBeEarlier: "To date cannot be earlier than from date",

  // Bulk Update Modal
  bulkUpdateRateBaseSnf: "Milk & Base Snf Update",
  updatingCollections: "Updating {count} collection(s)",
  dateRange: "Date Range",
  allDates: "All dates",
  newMilkRatePerKg: "New Milk Rate (₹/kg):",
  newBaseSnfPercent: "New Base SNF (%):",
  updateCollections: "Update Collections",
  updating: "Updating...",

  // Milk Rate Preview Modal
  previewMilkRateCalculations: "Preview Milk Rate Calculations",
  collectionsOnDate: "Collections on {date}",
  collectionsFromToDate: "Collections from {fromDate} to {toDate}",
  milkRateLabel: "Milk Rate",
  solid: "Solid",

  // Milk Rate Date Selection Modal
  singleDate: "Single Date",
  // selectDate: "",

  // Filter Modal
  dateRangeLabel: "Date Range",

  searchCustomersPlaceholder: "Search suppliers...",

  // Bulk Update Confirmation Modal
  confirmBulkUpdate: "Confirm Bulk Update",
  areYouSureApplyBulkChanges: "Are you sure you want to apply these bulk changes?",
  collectionsToUpdate: "Collections to update",
  newBaseSnf: "New Base SNF",
  newSnfPercentage: "New SNF Percentage",
  newClr: "New CLR",
  updatingCollectionsCount: "Updating {count} collection(s)",
  newRate: "New Rate",
  newAmount: "New Amount",
  confirmAndUpdate: "Confirm & Update",

  // Final Submit Confirmation Modal
  importantConfirmation: "Important Confirmation",
  irreversibleChangesWarning: "Irreversible Changes Warning",
  pleaseBeAware: "Please be aware:",
  irreversibleChangesWarningText: "Once you click the submit button, these changes cannot be reverted to the previous state. All affected collections will be permanently updated with the new values.",
  areYouAbsolutelySureYouWantToProceed: "Are you absolutely sure you want to proceed?",
  submitChanges: "Submit Changes",

  // Report Types
  fullReportPro: "Full Report (Pro-Rata)",
  purchaseReportDayWisePro: "Purchase Report - Day Wise (Pro-Rata)",
  purchaseSummarySupplierWisePro: "Purchase Summary - Supplier Wise (Pro-Rata)",
  allSupplierBillPro: "All Supplier Bills (Pro-Rata)",
  supplierBillsPro: "Supplier Bills (Pro-Rata)",
  viewCompleteCollectionReport: "View Complete Collection Report",
  viewCollectionsByDate: "View Collections by Date",
  viewCollectionsAsPerSupplier: "View Collections as per Supplier",
  viewComprehensiveSupplierBills: "View Comprehensive Supplier Bills",
  viewIndividualSupplierBills: "View individual supplier bill",

  // Report Types
  fullReport: "Full Report",
  purchaseReportDayWise: "Purchase Report - Day Wise",
  purchaseSummarySupplierWise: "Purchase Summary - Supplier Wise ",
  allSupplierBill: "All Supplier Bills ",
  supplierBillsPro: "Supplier Bill (Pro-Rata)",
  supplierBills: "Supplier Bill",



  // Additional Labels
  selectReportType: "Select Report Type",
  selectReportTypeProRata: "Select Report type (Pro Rata)",
  pleaseSelectBothStartAndEndDates: "Please select both start and end dates",
  invalidReportTypeSelected: "Invalid report type selected",
  failedToGenerateReport: "Failed to generate report",
  failedToLoadSuppliers: "Failed to load suppliers",
  failedToUpdateSupplierInformation: "Failed to update supplier information",
  pleaseSelectDateRangeForReport: "Please select date range for report",
  noDataFoundForTheSelectedSupplierInTheSelectedDateRange: "No data found for the selected supplier in the selected date range",
  failedToGenerateSupplierReport: "Failed to generate supplier report",
  failedToGenerateProRataSupplierReport: "Failed to generate pro-rata supplier report",

  // Month Names
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",

  // Additional missing keys
  includeMilkRateBRateColumn: "Include Milk Rate (B-Rate) Column",
  backToReportSelection: "Back to Report Selection",
  editSupplier: "Supplier",
  databaseId: "Database ID",
  customerId: "Customer ID",
  notSpecified: "Not specified",
  id: "ID",

  // Warning and Success Messages
  milkRateUpdatedSuccessfully: "Milk rate updated successfully!",
  errorSavingMilkRatePleaseTryAgain: "Error saving milk rate. Please try again.",
  errorSavingMilkRateAndRateSettingsPleaseTryAgain: "Error saving milk rate and Rate settings. Please try again.",
  rateChartLoadedSuccessfully: "Rate chart loaded successfully",
  paymentSuccessfulYourWalletWillBeUpdatedShortly: "✅ Payment successful! Your wallet will be updated shortly.",
  individualMilkRateSavedSuccessfullyProRataCollection: "Individual milk rate saved successfully (Pro Rata Collection)",
  walletBalanceBelowFifty: "Your wallet balance is below ₹50. Please add funds immediately to avoid any service interruption.",
  closeAddMoneyModal: "Close add money modal",

  // Milk Rate Preview Modal
  bulkEditCollections: "Bulk Edit Collections",
  collectionsOn: "Collections on",
  items: "items",
  clrConversion: "CLR Conversion",
  mix: "Cow + Buffalo",
  baseSnf: "Base SNF",
  totalAmt: "Total Amt",
  finalAmt: "Final Amt",
  applyBulkChanges: "Apply Bulk Changes",

  // Milk Rate Date Selection Modal
  filterCollectionsForMilkRateUpdate: "Filter Collections for Milk Rate Update",

  // Rate Settings Modal
  changeFatSnfRatio: "Change Fat/SNF Ratio",
  changeBaseSNF: "Change Base SNF",
  changeClrConversionFactor: "Change CLR Conversion Factor",
  areYouSureChangeFatSnfRatioTo: "Are you sure you want to change Fat/SNF ratio to {value}?",
  areYouSureChangeBaseSNFTo: "Are you sure you want to change Base SNF to {value}?",
  areYouSureChangeClrConversionFactorTo: "Are you sure you want to change CLR Conversion Factor to {value}?",
  thisFatSnfRatioWillBeUsed: "This Fat/SNF ratio will be used for calculations.",
  thisBaseSNFWillBeUsed: "This Base SNF will be used for calculations.",
  thisClrConversionFactorWillBeUsed: "This CLR Conversion Factor will be used for calculations.",
  thisRateTypeWillBeUsedForCalculations: "This Rate Type will be used for calculations.",

  // Rate Type Change Confirmation
  confirmChangeRateType: "Are you sure you want to change the Rate Type to {value}?",
  changeBaseSnf: "Change Base SNF",
  confirmChangeBaseSnf: "Are you sure you want to change the Base SNF to {value}?",
  baseSnfWillBeUsedForCalculations: "This Base SNF will be used for calculations.",
  confirmChangeFatSnfRatio: "Are you sure you want to change the Fat/SNF ratio to {value}?",
  confirmChangeClrConversionFactor: "Are you sure you want to change the CLR Conversion Factor to {value}?",
  thisClrConversionFactorWillBeUsedForCalculations: "This CLR Conversion Factor will be used for calculations.",

  // New Supplier Modal
  fathersName: "Father's Name",
  enter10DigitPhoneNumber: "Enter 10-digit phone number",

  // Rate Settings Card
  configureYourMilkCalculationParameters: "Configure your milk calculation parameters",
  fatAndSNF: "Fat & SNF",
  fixedRate: "Fixed Rate",

  // Dairy & Owner Information Card
  dairyAndOwnerInfo: "Dairy & Owner Info",
  yourDairyAndContactDetails: "Your dairy and contact details",
  ownerName: "Owner Name",

  // Pro Rata Collection Component
  proRata: "Pro Rata",
  proRataBadge: "PRO RATA",
  set: "Set",
  status: "Status",
  setTheRateChart: "Set the rate chart",
  fatStepUp: "Fat Step-up",
  snfStepDown: "SNF Step-down",
  notConfigured: "Not Configured",
  proRataStatus: "Pro-rata Status",
  active: "Active",
  rateChartRequired: "Rate Chart Required",
  pleaseSetUpYourRateChartFirst: "Please set up your rate chart first before adding collections. This is required for proper pro-rata calculations.",
  setUpRateChart: "Set Up Rate Chart",

  // Edit Collection Modal Labels
  editCollection: "Edit Collection",
  supplier: "Supplier",
  backToEdit: "Back to Edit",
  previewChanges: "Preview Changes",
  confirmSave: "Confirm & Save",

  // Edit Supplier Modal
  selectSupplierPro: "Select Supplier (Pro-Rate)",
  selectSupplier: "Select Supplier ",

  searchSuppliers: "Search suppliers...",
  noSuppliersFound: "No suppliers found matching your search.",
  typeToSearchSuppliers: "Type to search for suppliers...",
  nameRequired: "Name *",
  enterSupplierName: "Enter supplier name",
  backToList: "Back to List",
  updateSupplier: "Update Supplier",

  // Preview Collections Modal
  pleaseReviewCollections: "Please review the following collections before submitting:",
  confirmAndSubmit: "Confirm & Submit",

  // Date Filter Modal
  fromDate: "From Date:",
  toDate: "To Date:",

  // Bulk Update Rate & Base SNF
  bulkUpdateRateAndBaseSNF: "Milk & Snf Update",

  // Bulk Update Modal
  newBaseSNF: "New Base SNF (%)",
  enterNewBaseSNF: "Enter new base SNF",

  // Bulk Update Rate & SNF
  enterNewBaseSnf: "Enter new base SNF",

  // Supplier Details Modal
  supplierID: "Supplier ID",
  customerID: "Supplier ID",
  supplierInformation: "Supplier Information",
  editSupplierInfo: "Edit Supplier Info",
  downloadReport: "Download Report",
  proRataCollectionsModal: "Pro Rata Collections",
  rechargeBonusMessage: "You will get ₹100.00 extra on this recharge!",
  rechargeBonusMessage10Percent: "You will get ₹{amount} extra on this recharge!",
  rechargeBonusMessage5Percent: "You will get ₹{amount} extra on this recharge!",
  example500Recharge: "Example: ₹500 Recharge = ₹525 in Wallet",
  example1000Recharge: "Example: ₹1000 Recharge = ₹1100 in Wallet",
  // Excel Table Headers
  shift: "Shift",
  animal: "Animal",
  totalWeight: "Total Weight:",
  // Customer Search Dropdown
  searchSupplier: "Search Supplier",
  noSupplierFound: "No Supplier found",
  noId: "No ID",
  selectCustomer: "Select Customer",
  loadingCollections: "Loading collections...",
  loadMore: "Load More",
  collectionSummary: "Collection Summary",
  noCollectionsFound: "No collections found.",
  // Table Headers
  sNo: "S.No.",
  dateAndShift: "Date & Shift",
  date: "Date",
  name: "Name",
  qtyKg: "Qty (kg)",
  fatPercent: "Fat %",
  snfPercent: "SNF %",
  clr: "CLR",
  fatKg: "Fat (kg)",
  snfKg: "SNF (kg)",
  fatRate: "Fat Rate",
  snfRate: "SNF Rate",
  fatStepUp: "FAT Step up",
  snfStepDown: "SNF Step Down",
  bRate: "B Rate",
  rate: "Rate",
  milkRate: "Milk Rate",
  baseSnf: "Base SNF",
  amount: "Amount",
  actions: "Actions",
  retry: "Retry",
  thisBulkUpdateCannotBeUndone: "This action cannot be undone.",
  addNewSupplier: "Add New supplier",
  // Pro-rata Calculation Note
  proRataCalculationNote: "* Pro-rata calculation applied where Fat% > 6.5. Rate formula: Base Rate + ((Fat%-6.5)×{fatStepUpRate}) + ((SNF%-9)×{snfStepDownRate})",
  fatSnfRatioNote: "Fat/SNF Ratio: {ratio} - Used for calculating Fat Rate ({fatPercent}% of rate / 6.5) and SNF Rate ({snfPercent}% of rate / base SNF)",
  // Rate Change Modal
  newMilkRate: "New Milk Rate (₹/Kg)",
  enterNewMilkRate: "Enter new milk rate",
  updateRate: "Update Rate",
  starterBonusRange: "₹500 - ₹999",
  premiumBonusRange: "₹1000+",
  getExtraBonusOnRecharge: "Get extra bonus on recharge",
  getExtra5PercentBonus: "Get Extra 5% Bonus",
  addBetween500And999: "On recharge of ₹500 - ₹999",
  getExtra10PercentBonus: "Get Extra 10% Bonus",
  add1000OrMore: "On recharge of ₹1000 or more",
  // Percentage Confirmation Modal
  highPercentageValue: "High Percentage Value",
  enteredValueGreaterThan: "You entered {field} value greater than {max}%",
  noChangeValue: "No, Change Value",
  yesKeepValue: "Yes, Keep Value",
  // Submission Loading Overlay
  submittingCollectionsToServer: "Submitting collections to server...",

  // Active Filters Summary
  activeFilters: "Active Filters:",
  showingCollectionsFor: "Showing collections for {name}",
  showingCollectionsForOn: "Showing collections for {name} on {date}",
  showingCollectionsForFromTo: "Showing collections for {name} from {fromDate} to {toDate}",
  showingAllCollectionsOn: "Showing all collections on {date}",
  showingAllCollectionsFromTo: "Showing all collections from {fromDate} to {toDate}",
  sorting: "Sorting:",
  byCreationTime: "by creation time",
  clearSupplier: "Clear Supplier",
  clearDates: "Clear dates",

  // Support Modal
  contactSupport: "Contact Support",
  whatsappSupport: "WhatsApp Support",
  callSupport: "Call Support",
  supportNumber: "+91 7454 860 294",

  // Bulk Collection Support Section
  havingTroubleAddingMoney: "Having trouble adding money?",
  contactUs: "Contact Us",

  // Offers Support Section
  needHelpWithOffers: "Need help with offers?",

  // Navbar Support Button
  support: "Support",

  // Toast Messages for Pro-Rata Collections
  collectionUpdatedSuccessfully: "Collection updated successfully!",
  updatedProRataCollectionsWithMilkRate: "Updated {successful} pro-rata collections with milk rate. Failed to update {failed} collections.",
  successfullyUpdatedProRataCollectionsWithMilkRate: "Successfully updated {count} pro-rata collections with milk rate {rate}.",
  successfullyUpdatedProRataCollections: "Successfully updated {count} pro-rata collection(s).",
  noProRataCollectionsFoundToUpdate: "No pro-rata collections found to update.",
  failedToApplyMilkRatesAndBaseSnf: "Failed to apply milk rates and base SNF. Please try again.",
  failedToUpdateCollections: "Failed to update collections. Please try again.",
  pleaseEnterAtLeastMilkRateSnfOrClrToUpdate: "Please enter at least milk rate, SNF percentage, or CLR to update",
  // Validation Error Messages
  collectionDateRequired: "Collection date is required",
  fatPercentCannotExceed15: "Fat percent cannot exceed 15%",
  snfPercentCannotExceed15: "SNF percent cannot exceed 15%",
  clrValueInvalid: "CLR value \"{value}\" is invalid. Must have at least 2 digits (e.g., 27.50)",

  // Customer Validation Error Messages
  noProRataCollectionsFoundForSelectedDateRange: "No pro-rata collections found for the selected date range",
  failedToLoadProRataCollectionsForPreview: "Failed to load pro-rata collections for preview. Please try again.",

  // Bulk Update Error Messages
  pleaseEnterAtLeastOneValueToUpdate: "Please enter at least one value to update",
  noCollectionsFoundToUpdate: "No collections found to update",

  // Bulk Update Result Messages
  collectionReachedMaximumEditLimit: "Collection {id} has reached maximum edit limit ({message})",
  failedToUpdateCollection: "Failed to update collection {id}: {message}",
  bulkUpdateFailed: "Bulk update failed. Please try again.",
  collectionReachedMaximumEditLimitWithCount: "Collection {id} has reached maximum edit limit ({editCount}/2)",
  invalidCollectionSelectedForDeletion: "Invalid collection selected for deletion",
  updatedCollectionsWithMilkRatePartially: "Updated {successful} collections with milk rate. Failed to update {failed} collections.",
  successfullyUpdatedCollectionsWithMilkRate: "Successfully updated {count} collections with milk rate {rate}.",
  successfullyUpdatedCollections: "Successfully updated {count} collections.",
  successfullyUpdatedProRataCollectionsWithRateChart: "Successfully updated {count} pro-rata collection(s) with rate chart.",
  noCollectionsWereUpdated: "No collections were updated. Please check if collections exist and try again.",
  rateChartFunctionalityWillBeImplementedSoon: "Rate chart functionality will be implemented soon",
  pleaseEnterAValidMilkRate: "Please enter a valid milk rate",
  toDateCannotBeEarlierThanFromDateForFilter: "To date cannot be earlier than from date",
  successfullyUpdatedCollectionsWithAccurateAmounts: "✅ Successfully updated {updatedCount} collections with accurate amounts.\n❌ Failed to update {errorCount} collections.\n\nReports will now show correct amounts!",
  errorFixingReportAmounts: "❌ Error fixing report amounts. Please try again.",
  confirmUpdateAllCollectionsWithAccurateAmounts: "This will update all collections with accurate amounts. Are you sure?",
  failedToLoadCollections: "Failed to load collections. Please try again later.",
  failedToLoadCollectionsForCustomerOnDate: "Failed to load collections for {customerName} on {date}.",
  failedToLoadCollectionsForCustomerBetweenDates: "Failed to load collections for {customerName} between {fromDate} and {toDate}.",
  failedToLoadCollectionsForCustomer: "Failed to load collections for {customerName}.",
  failedToLoadCollectionsOnDate: "Failed to load collections on {date}.",
  failedToLoadCollectionsBetweenDates: "Failed to load collections between {fromDate} and {toDate}.",
  failedToGeneratePreview: "Failed to generate preview. Please try again.",
  failedToApplyBulkUpdates: "Failed to apply bulk updates. Please try again.",
  updatedCollectionsWithFieldsPartially: "Updated {successful} collections with {fieldsText}. Failed to update {failed} collections.",
  successfullyUpdatedCollectionsWithFields: "Successfully updated {successful} collections with {fieldsText}.",
  noCollectionsFoundForSelectedDateRangeAndCollectionType: "No collections found for the selected date range and collection type",
  noStandardCollectionsFoundInDateRange: "No standard collections found in the selected date range",
  errorSavingRateSettings: "Error saving rate settings. Please try again.",
  errorSavingMilkRateAndRateSettings: "Error saving milk rate and rate settings. Please try again.",
  snfStepMustBeBetween7And12: "SNF step must be between 7% and 12%",
  snfStepMustBeLessThanPreviousSteps: "SNF step must be less than previous steps",
  fatStepCannotBeGreaterThan12: "Fat step cannot be greater than 12%",
  fatStepMustBeGreaterThanPreviousSteps: "Fat step must be greater than previous steps",
  pleaseEnterAtLeastOneValidStep: "Please enter at least one valid step and rate in either Fat Step-up Rates or SNF Step-down Rates",
  milkRateUpdatedToXSuccessfully: "Milk rate updated to ₹{rate}/L successfully!",
  supplierXUpdatedSuccessfully: "Supplier {name} updated successfully!",
  failedToUpdateSupplier: "Failed to update supplier. Please try again.",
  supplierNameIsRequired: "Supplier name is required",
  rateTypeAutoSavedSuccessfully: "Rate type auto-saved successfully!",
  failedToAutoSaveRateType: "Failed to auto-save rate type. Please try submit button.",
  snfPercentMustBeAtLeast4: "SNF percent must be at least 4.0%",
  snfPercentCannotExceed11: "SNF percent cannot exceed 11.0%",
  clrValueInvalidMustHaveAtLeast2Digits: "CLR value \"{value}\" is invalid. Must have at least 2 digits (e.g., 27.50)",
  fatPercentMustBeAtLeast2: "Fat percent must be at least 2.00%",
  rateSettingsSavedSuccessfully: "Rate settings saved successfully!",
  milkRateXAndRateSettingsSavedSuccessfully: "Milk rate ₹{rate}/kg and rate settings saved successfully!",

  // Rate Chart Messages
  rateChartSavedSuccessfully: "Rate chart saved successfully!",
  errorSavingRateChart: "Error saving rate chart: {message}",
  errorSavingFatSnfRatio: "Error saving Fat/SNF ratio:",

  // Dairy Logo
  dairyLogo: "Dairy Logo",
  logoNotSet: "No logo set",
  logoUpload: "Upload Logo",
  logoReplace: "Replace Logo",
  logoRemove: "Remove Logo",
  logoSelectFile: "Please select a logo file first.",
  logoMustBePngJpgWebp: "Logo must be a PNG, JPG, or WebP image.",
  logoMustBe2MbOrSmaller: "Logo must be 2 MB or smaller.",
  logoUploadValidImage: "Please upload a valid PNG, JPG, or WebP image.",
  logoHint: "Your logo appears in the top-left corner of every PDF report. PNG, JPG, or WebP, up to 2 MB.",
  logoUpdatedSuccessfully: "Logo updated successfully!",
  logoRemovedSuccessfully: "Logo removed successfully!",
  logoUploadFailed: "Failed to upload logo. Please try again.",
  logoRemoveFailed: "Failed to remove logo. Please try again.",
  logoRemoveConfirmMessage: "Are you sure you want to remove your dairy logo?",
  logoChangeButton: "Change Logo",
};
